import { fetchJson } from "./http";
import type { Metadata, ServiceSlug } from "./types";
import { isMetadata } from "./guards";
import { toRFC3339 } from "../utils/time";

export async function getSpanNames(
  serviceSlug: ServiceSlug,
  options?: {
    rangeFrom?: Date;
    rangeTo?: Date;
    limit?: number;
    signal?: AbortSignal;
  },
): Promise<string[]> {
  const searchParams: Record<string, string> = {};
  if (options?.rangeFrom) {
    searchParams.range_from = toRFC3339(options.rangeFrom);
  }
  if (options?.rangeTo) {
    searchParams.range_stop = toRFC3339(options.rangeTo);
  }
  if (options?.limit != null) {
    searchParams.limit = String(options.limit);
  }

  const result = await fetchJson<string[] | null>("/metadata/span_names", {
    serviceSlug,
    searchParams: Object.keys(searchParams).length > 0 ? searchParams : undefined,
    signal: options?.signal,
  });
  return Array.isArray(result) ? result : [];
}

export async function getMetadata(
  serviceSlug: ServiceSlug,
  options?: {
    rangeFrom?: Date;
    rangeTo?: Date;
    signal?: AbortSignal;
  },
): Promise<Metadata> {
  const searchParams: Record<string, string> = {};
  if (options?.rangeFrom) {
    searchParams.range_from = toRFC3339(options.rangeFrom);
  }
  if (options?.rangeTo) {
    searchParams.range_stop = toRFC3339(options.rangeTo);
  }

  return fetchJson<Metadata>(
    "/metadata",
    {
      serviceSlug,
      searchParams: Object.keys(searchParams).length > 0 ? searchParams : undefined,
      signal: options?.signal,
    },
    isMetadata,
  );
}
